const AboutSection = () => {
  return (
    <div id="about">
      <div className="relative mt-20 min-h-[400px]">
        <div className="text-center">
          <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-20 tracking-wide">
            About{" "}
            <span className="bg-gradient-to-r from-cyan-500 to-cyan-600 text-transparent bg-clip-text">
              Us
            </span>
          </h2>
        </div>
        <div className="flex flex-wrap mt-10 lg:mt-20 space-y-4">
          <p className="text-justify">
            At SalePersona, we help businesses grow with expert branding, lead generation, social media marketing, website development, email campaigns, and data appending.
            Whether you're looking to attract new prospects, boost sales, expand your audience, or strengthen client relationships—we've got you covered.
          </p>
          <p className="text-justify">
            With cutting-edge technology and smart marketing strategies, we drive real engagement and results. Plus, our high-quality business leads connect you with the right customers,
            so you can focus on what matters most—growing your business.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
